// src/routes/rolesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Roles from '../pages/roles/Roles';
import CreateRole from '../pages/roles/CreateRole';
import EditRole from '../pages/roles/EditRole';
import ProtectedRoute from '../components/global/ProtectedRoute';

const rolesRoutes = (
    <>
        <Route
            path="/settings/roles"
            element={
                <ProtectedRoute requiredPermission="roles.manage">
                    <Roles />
                </ProtectedRoute>
            }
        />
        <Route
            path="/settings/roles/create"
            element={
                <ProtectedRoute requiredPermission="roles.manage">
                    <CreateRole />
                </ProtectedRoute>
            }
        />
        <Route
            path="/settings/roles/:id/edit"
            element={
                <ProtectedRoute requiredPermission="roles.manage">
                    <EditRole />
                </ProtectedRoute>
            }
        />
    </>
);

export default rolesRoutes;
